var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { DataStore } from '../../../../ts/helpers/DataStore';
import { Form } from '../../singles/assessment';
import { Canvg } from 'canvg';
const notCompanyFieldsId = ['q_1', 'q_2', 'q_3', 'q_4', 'q_5', 'q_6', 'q_7', 'q_8', 'q_9', 'q_10', 'q_11', 'q_12', 'q_13', 'q_14', 'q_15', 'q_16', 'q_17', 'q_18', 'q_20', 'q_21', 'q_22', 'q_23', 'q_24', 'q_25'];
const notCompanyIds = ['section-company_size-title', 'section-company_size', 'section-financial_questions-title'];
export class Synthesis extends Component {
    constructor(isDebugEnabled = false) {
        super('Synthesis', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const mode = $('#synthesis').data('mode');
            if (mode !== '') {
                yield DataStore.init(mode);
                if (!Form.isComplete()) {
                    $('#alert-incomplete').removeClass('d-none');
                    $('#synthesis-loader, #synthesis').remove();
                }
                // UNCOMMENT TO EXPORT BLANK PDF
                //$('[data-type="multiselect"] p, [data-type="select"] p').remove();
                Object.entries(DataStore.get()).forEach(([key, value]) => {
                    if (!value || (notCompanyFieldsId.includes(key) && DataStore.get('is_company') === 'no')) {
                        $(`*[data-key="${key}"]`).parents('.form-field').remove();
                        return;
                    }
                    // UNCOMMENT TO EXPORT BLANK PDF
                    //return;
                    if (key === 'answers') {
                        Object.entries(value).forEach(([key, value]) => {
                            $('.form-field-likert[data-answer-id="' + key + '"] .likert-result[data-value="' + value + '"]').addClass('checked');
                        });
                    }
                    ;
                    if (key === 'enddate') {
                        const date = new Date();
                        date.setTime(value);
                        $('.assessment-date').text(date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear());
                    }
                    if (key === 'domain') {
                        $('.assessment-domain').text(value);
                    }
                    if (key === 'company') {
                        $('.company-title-no-dash').text(value);
                        $('.company-title').text(value + ' — ');
                    }
                    const field = $('[data-key="' + key + '"]');
                    if (field.length === 0)
                        return;
                    const type = $('[data-key="' + key + '"]').data('type');
                    if (type === 'text')
                        $('[data-key="' + key + '"]').text(value);
                    if (type === 'select')
                        $('[data-key="' + key + '"] p:not([data-value="' + value + '"])').remove();
                    if (type === 'multiselect') {
                        $('[data-key="' + key + '"] p').each((choice) => {
                            if (!value.includes(choice.data('value')))
                                choice.remove();
                            //choice.remove();
                        });
                        if (value.length === 1)
                            $('[data-key="' + key + '"] > span span').remove();
                        //$('[data-key="' + key + '"] > span span').remove();
                    }
                });
                // Hide irrelevant elements
                notCompanyIds.forEach((fieldId) => {
                    const parent = $(`#${fieldId}`);
                    if (DataStore.get('is_company') === 'no') {
                        parent.addClass('d-none-company');
                    }
                    else {
                        parent.removeClass('d-none-company');
                    }
                });
                $('#synthesis-loader').remove();
                $('#synthesis').removeClass('d-none');
                Synthesis.computeAnalysis();
                Synthesis.computeRecommendations();
                Synthesis.drawDiagram();
                //if ($('canvas.synthesis').length > 0) new Graphic('canvas.synthesis');
            }
            $('#wheel-summary #hovers > *').on('mouseenter', (event, area) => {
                const areaIndex = area.attr('id').replace('hover_', '');
                $('#wheel-summary .hovered').removeClass('hovered');
                $('#wheel-summary #text-it-' + areaIndex + ',#wheel-summary #text-fr-' + areaIndex + ', #wheel-summary #text-de-' + areaIndex + ', #wheel-summary #area_' + areaIndex).addClass('hovered');
            });
            $('#wheel-summary').on('mouseleave', () => {
                $('#wheel-summary .hovered').removeClass('hovered');
            });
            // compare
            $('#select-compare-to').on('change', (event, select) => {
                Synthesis.drawDiagram(select.val());
            });
            //$('#select-compare-to').val('237').trigger('change');
            this.success();
        });
    }
    static computeAnalysis() {
        return __awaiter(this, arguments, void 0, function* (formID = null) {
            let analysis = {
                dimensions: [],
                quadrant: []
            };
            let data;
            if (!formID) {
                data = DataStore.get().answers;
            }
            else {
                const response = yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'load_form',
                        'form_id': formID,
                    },
                    dataType: 'json'
                });
                data = response.answers;
            }
            Object.entries(data).forEach(([id, value]) => {
                const idParts = id.split('_');
                const dimensionsID = parseInt(idParts[0]);
                const quadrantID = (parseInt(idParts[0]) - 1) * 3 + parseInt(idParts[1]);
                if (!analysis.dimensions[dimensionsID])
                    analysis.dimensions[dimensionsID] = 0;
                analysis.dimensions[dimensionsID] += parseInt(value);
                if (!analysis.quadrant[quadrantID])
                    analysis.quadrant[quadrantID] = 0;
                analysis.quadrant[quadrantID] += parseInt(value);
            });
            analysis.dimensions.forEach((value, index) => {
                analysis.dimensions[index] = value / 24;
            });
            analysis.quadrant.forEach((value, index) => {
                analysis.quadrant[index] = value / 8;
            });
            if (!formID)
                Synthesis.analysis = analysis;
            return analysis;
        });
    }
    static computeRecommendations() {
        $('.recommendation').each((recommendation) => {
            let conditions = recommendation.data('conditions').split(';');
            //const test = recommendation.data('conditions') === '4.1.1,4.1.2,4.1.3,4.1.4,4.1.8=1';
            conditions.forEach((condition) => {
                let isValid = true;
                condition.split('&').forEach((conditionPart) => {
                    if (condition.split('=').length < 2)
                        return;
                    let isQuestionValid = false;
                    const questions = conditionPart.split('=')[0].split(',');
                    const values = conditionPart.split('=')[1].split(',');
                    questions.forEach((question) => {
                        let questionValue = question.indexOf('q_') !== -1 ? DataStore.get()[question] : DataStore.get().answers[question.replace(/\./gi, '_')];
                        isQuestionValid = values.includes(questionValue) ? true : isQuestionValid;
                        //if (test) console.log(question, questionValue, isQuestionValid);
                    });
                    isValid = isQuestionValid ? isValid : false;
                    //if (test) console.log(conditionPart, isQuestionValid);
                });
                //if (test) console.log(isValid);
                if (isValid)
                    recommendation.removeClass('d-none');
            });
            $('.export-text-split').each((textBloc) => {
                if (textBloc.hasClass('d-none'))
                    return;
                textBloc.get(0).childNodes.forEach((node) => {
                    const tagName = node.tagName;
                    if (['P', 'STRONG'].indexOf(tagName) !== -1) {
                        $(node).addClass('export export-text');
                    }
                    else if (tagName === 'UL') {
                        node.childNodes.forEach((li) => {
                            const nodeTagName = li.tagName;
                            if (nodeTagName === 'LI')
                                $(li).addClass('export export-text');
                        });
                    }
                });
            });
        });
        // Congratulations
        let showCongratulations = true;
        $('.recommendation').each((recommendation) => {
            if (recommendation.hasClass('d-none'))
                return;
            const recommendationID = recommendation.attr('id').replace('recommendation-', '');
            if (['2A', '4B', '5A', '6A', '10A'].includes(recommendationID))
                showCongratulations = false;
        });
        if (showCongratulations) {
            $('#congratulation').removeClass('d-none');
        }
        else {
            $('#congratulation').addClass('d-none');
        }
    }
    static drawDiagram() {
        return __awaiter(this, arguments, void 0, function* (comparisonId = null) {
            if ($('#canvas-diagram').length === 0)
                return;
            $('.wheel-summary-result, .wheel-summary-compare').attr('d', 'x');
            $('#comparison-legend').addClass('d-none').find('p').removeClass('export');
            $('.wheel-summary-result').attr('d', this.createShapeFromAnalysis(Synthesis.analysis));
            if (comparisonId) {
                const comparisonAnalysis = yield this.computeAnalysis(parseInt(comparisonId));
                $('.wheel-summary-compare').attr('d', this.createShapeFromAnalysis(comparisonAnalysis));
                if (comparisonId !== '') {
                    $('#comparison-legend').removeClass('d-none').find('p').addClass('export');
                    $('.comparison-company').text($('#select-compare-to option[value="' + comparisonId + '"]').text());
                }
            }
            // Stuff for printing
            const canvasDiagram = $('#canvas-diagram');
            const context = $('#canvas-diagram').get(0).getContext('2d');
            context.fillStyle = '#fff';
            context.fillRect(0, 0, 1280, 880);
            const svgCanvas = Canvg.fromString(context, $('#svg-diagram').html().replace(/\r?\n|\r/g, '').trim());
            svgCanvas.resize(1280, 880, 'xMidYMid meet');
            svgCanvas.render();
            canvasDiagram.css({
                width: '14cm',
                height: '9.58cm',
            });
        });
    }
    static createShapeFromAnalysis(analysis) {
        const center = { x: 437, y: 300 };
        const maxRadius = 230;
        let path = [];
        analysis.quadrant.forEach((value, index) => {
            path.push(this.createPoint(center, this.getCirclePoint(15 + (index - 1) * 30, (value - 1) * maxRadius / 3), index));
        });
        return path.join('') + 'z';
    }
    static createPoint(center, point, index) {
        return (index === 1 ? 'M' : 'L') + this.round(center.x + point.x) + ',' + this.round(center.y + point.y);
    }
    static getCirclePoint(angle, radius) {
        const angleRad = (angle - 90) / 180 * Math.PI;
        return { x: radius * Math.cos(angleRad), y: radius * Math.sin(angleRad) };
    }
    static round(number) {
        return Math.round((number + Number.EPSILON) * 100) / 100;
    }
}
